import useDuplicateExamination from './useDuplicateExamination';

export default useDuplicateExamination;
